import React from "react";
import {
  Snackbar,
  Button
} from "@material-ui/core";
import { Text } from "ui";

interface Props {
  open: boolean;
  onClose: () => void;
  message: string;
}
export class ErrorConfirm extends React.Component<Props> {
  public render() {
    const { open, onClose, message } = this.props;
    return (
      <Snackbar
        open={open}
        onClose={onClose}
        message={message}
        action={[
          <Button key="ok" onClick={onClose}>
            <Text color="white">Ok</Text>
          </Button>
        ]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorConfirm.tsx